import React, { useContext, useEffect } from "react";
import { Card, Button } from "reactstrap";
import AnvyMediumImg from "@workspace/main/src/assets/images/Anvy Medium.png";
import { InterviewContext } from "../../../context/InterviewProvider";
import RecordingTime from "../components/RecordingTime";
import { useNavigate } from "react-router-dom";

const InterviewEnd = ({ setOffVideoCanvasOpen, onCompleteInterview }) => {
  const navigate = useNavigate();
  const interviewContext = useContext(InterviewContext);

  useEffect(() => {
    if (
      interviewContext?.convertedVideoUrl &&
      interviewContext?.chatHistory &&
      interviewContext?.chatHistory.length > 0 &&
      interviewContext?.botTimestamps
    )
      onCompleteInterview(
        interviewContext?.convertedVideoUrl,
        interviewContext?.chatHistory,
        interviewContext?.botTimestamps
      );
  }, [
    interviewContext?.convertedVideoUrl,
    interviewContext?.chatHistory,
    interviewContext?.botTimestamps,
  ]);

  return (
    <div
      className="d-flex gap-2 "
      style={{
        height: "100vh",
        width: "100%",
        backgroundColor: "#FFFFFF",
      }}
    >
      <div
        className="d-flex flex-column "
        style={{
          width: "100%",
          paddingLeft: "30px",
          paddingRight: "30px",
          paddingTop: "15px",
        }}
      >
        <div className="d-flex justify-content-center mb-1">
          <span
            style={{
              fontSize: "23px",
              color: "#0A4FAE"
            }}
            className="fw-semibold mb-3"
          >
            Thank you for attending interview with us!
          </span>
        </div>
        <hr className="p-0 m-0" />
        <div
          className="d-flex align-items-center justify-content-center"
          style={{
            height: "90vh",
          }}
        >
          <div className="d-flex align-items-center justify-content-center flex-column">
            <span
              className="mb-4"
              style={{
                textAlign: "center",
                width: "35%",
                fontSize: "16px"
              }}
            >
              We truly appreciate your interest in the role and the effort you
              put into showcasing your skills and experiences. We will review
              the results and get back to you with the outcome shortly. If you
              have any questions in the meantime, feel free to reach out.
            </span>
            <img
              src={AnvyMediumImg}
              alt="Chatbot Avatar"
              style={{
                width: "200px",
                height: "auto",
                objectFit: "cover",
              }}
            />
            <span style={{fontSize: "23px"}} className="fw-semibold mt-3 mb-3">Meeting Ended</span>
            <RecordingTime title="Total Recording Duration" />
            <Button
              className="submit-btn mt-5"
              type="button"
              style={{
                borderRadius: "100vh",
                backgroundColor: "#0A4FAE",
                color: "#fff",
                padding: "10px 30px",
              }}
              onClick={() => {
                navigate("/job-portal/home");
              }}
            >
              Done
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterviewEnd;
